import React, { useEffect } from 'react';
import { Box } from '@mui/material'; // Assuming Box is imported from MUI
import Chart from 'chart.js/auto'; // Import Chart.js for React
import './DonutChart.css';

const DonutChart = ({ sessionCategoryData }) => {
  // Use data from props or fall back to defaults if not provided
  const chartData = {
    total: sessionCategoryData?.total || 0,
    one_on_one: sessionCategoryData?.one_on_one || 0,
    group: sessionCategoryData?.group || 0,
    prime: sessionCategoryData?.prime || 0,
  };

  const data = {
    datasets: [
      {
        label: 'Session Type',
        data: [chartData.one_on_one, chartData.group, chartData.prime],
        backgroundColor: [
          'rgb(123, 111, 247)', // One-on-One
          'rgb(168, 247, 182)', // Group
          'rgb(244, 214, 125)', // Prime
        ],
        borderColor: ['rgba(107, 96, 231, 1)', 'rgba(123, 207, 140, 1)', 'rgba(236, 177, 0, 1)'],
        borderWidth: 1,
        borderRadius: 15,
        offset: 20,
      },
    ],
  };

  const config = {
    type: 'doughnut',
    data,
    options: {
      responsive: true,
      plugins: {
        tooltip: {
          callbacks: {
            label: tooltipItem => {
              // Custom tooltip content based on sessionCategoryData
              const sessionLabels = ['One on One Session', 'Group Session', 'Prime Session'];
              const datasetIndex = tooltipItem.datasetIndex;
              const dataIndex = tooltipItem.dataIndex;
              return `${sessionLabels[dataIndex]}: ${tooltipItem.raw}`;
            },
          },
        },
        legend: {
          display: false, // Hide legend if you want only the text in the center
        },
      },
    },
    plugins: [
      {
        beforeDraw: chart => {
          const ctx = chart.ctx;
          const centerX = chart.chartArea.left + (chart.chartArea.right - chart.chartArea.left) / 2;
          const centerY = chart.chartArea.top + (chart.chartArea.bottom - chart.chartArea.top) / 2;
          const total = chartData.total;

          // Draw the text in the center of the chart
          ctx.save();
          ctx.font = '12px Poppins';
          ctx.fillStyle = '#000'; // black color
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText('Total Session: ', centerX, centerY); // Render the text

          // Apply the requested styling for the total number
          ctx.font = '600 16px Poppins';
          ctx.fillStyle = '#000';
          ctx.textAlign = 'center';
          ctx.fillText(total, centerX, centerY + 20); // Increased the offset for better spacing

          ctx.restore();
        },
      },
    ],
  };

  useEffect(() => {
    const ctx = document.getElementById('myChart');
    const myChart = new Chart(ctx, config);

    // Cleanup on unmount to avoid memory leaks
    return () => {
      myChart.destroy();
    };
  }, [chartData]); // Update dependency to chartData

  return (
    <Box>
      <div className="chartCard">
        <canvas id="myChart"></canvas>
      </div>
    </Box>
  );
};

export default DonutChart;
